import { getAttribute } from "@api/attributes";
import { API_URL } from "@api/constants";
import CourseCompletion from "@api/types/course-completion";
import React, { FC, useContext } from "react";

import Button from "@components/Button";
import UserContext from "@components/UserContext";

const LaunchCourseButton: FC<{
  completion: CourseCompletion;
  buttonText?: string;
}> = ({ completion, buttonText = "Launch Course" }) => {
  const { token } = useContext(UserContext);

  function launchLink(completion) {
    return completion.isLegacyCourse
      ? getAttribute(completion.registrationInfo.orderInfo, "courseLaunch")
      : API_URL + "/xapi/course/launch" + "?completionId=" + completion.id + "&token=" + token;
  }

  function launchButton(completion: CourseCompletion) {
    const defaultLaunchButton =
      completion.coursePackageName && completion.coursePackageName.length > 0
        ? `Launch ${completion.coursePackageName}`
        : "Launch Course";

    const variantPkg = completion.courseObject.variantPackages.find((vp) =>
      vp.packages.find((p) => p.id === completion.coursePackageId)
    );

    if (!variantPkg) {
      return defaultLaunchButton;
    }

    const pkg = variantPkg.packages.find((p) => p.id === completion.coursePackageId);

    return pkg && pkg.launchButton ? pkg.launchButton : defaultLaunchButton;
  }

  return (
    <Button>
      <a href={launchLink(completion)} target={"_blank"}>
        {launchButton(completion)}
      </a>
      {/* language=CSS */}
      <style jsx>
        {`
          a {
            text-decoration: none;
            color: white;
          }
        `}
      </style>
    </Button>
  );
};

export default LaunchCourseButton;
